import React, { useState, useContext, useEffect } from 'react';
import cn from 'classnames';
import { useField, useFormikContext } from 'formik';
import Icon from 'components/UI/Icon';
import Input from 'components/UI/Input';
import { fileLimit, fileSizeLimit } from '../constatnts';
import {
  ErrorsShakeHubContext,
  ThemeContext,
  getShortFileName,
  calculateFileSizeTitle,
} from '../utils';
import { FormError } from '../FormError/FormError';

import * as styles from './FormFieldUpload.module.scss';

export const FormFieldUpload = ({ className, content, ...props }) => {
  const formik = useFormikContext();
  const [focused, setFocused] = useState(false);
  const [field, meta, helpers] = useField(props.name);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const fieldValues = field?.value;

  const error = props.error || meta.error;
  const showError = meta.touched && error;
  const errorsShakeHub = useContext(ErrorsShakeHubContext);
  const disabled = fieldValues?.length >= fileLimit;

  const theme = useContext(ThemeContext);
  const { limitation, attach } = content;

  const limitationsHint = limitation?.replace('{size}', calculateFileSizeTitle(fileSizeLimit));

  useEffect(() => {
    helpers.setValue(uploadedFiles);
  }, [uploadedFiles]);

  useEffect(() => {
    if (formik.status === 'success') {
      setUploadedFiles([]);
    }
  }, [formik.status]);

  const removeFileHandler = deleteIndex => {
    setUploadedFiles(uploadedFiles.filter((_, i) => deleteIndex !== i));
  };

  const preparedProps = {
    formik,
    errorsShakeHub,
    theme,
    focused,
    setFocused,
    disabled,
    ...props,
    onChange: e => {
      const files = e.target.files;
      const filesArray = Array.from(files);
      setUploadedFiles(prev => [...prev, ...filesArray].slice(0, fileLimit));
      helpers.setTouched(true);
      e.target.value = null;
    },
  };

  return (
    <div className={cn(styles.wrapper, styles[theme])}>
      <div className={styles.attachRow}>
        <div className={cn(styles.field, disabled && styles.disabled, className)}>
          <Icon className={styles.clipIcon} name="clip" />
          {attach}
          <Input {...preparedProps} className={styles.inputLabel} />
        </div>
        <p className={styles.limitationsHint}>{limitationsHint}</p>
      </div>
      <div className={styles.uploadFilesWrapper}>
        {fieldValues?.length > 0 &&
          fieldValues.map(({ name, size }, i) => (
            <div key={name} className={styles.uploadFile} title={name}>
              {`${getShortFileName(name)} (${calculateFileSizeTitle(size)})`}
              <button
                type="button"
                className={styles.removeFileButton}
                onClick={() => removeFileHandler(i)}
              >
                <Icon name="close" />
              </button>
            </div>
          ))}
      </div>
      {showError && <FormError value={meta.error} active={meta.touched} theme="attach" />}
    </div>
  );
};
